import { useContext, useEffect, useState } from "react";
import { MdEmail, MdLocationPin, MdPhone } from "react-icons/md";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import { company, navigationItems } from "../siteContent";

export default function Footer(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection bg-dark tff-footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-5">
            <img src={company.logo} alt={company.shortName} className="tff-footer-logo rounded-pill" />
            <h4 className="font-bold text-light mt-4 mb-3">{company.shortName}</h4>
            <p className="font-light text-light mb-0 tff-footer-copy">{company.tagline}</p>
          </div>

          <div className="col-lg-3">
            <h5 className="font-bold text-light mb-3">Explore</h5>
            {navigationItems.map((item) => (
              <button
                key={item.item}
                className="btn tff-footer-link"
                onClick={() => {
                  appContext.navTo({ item: item.item });
                }}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="col-lg-4">
            <h5 className="font-bold text-light mb-3">Contact</h5>
            <div className="tff-footer-contact-item">
              <MdLocationPin size={18} className="text-secondary me-2" />
              <span>{company.location}</span>
            </div>
            <div className="tff-footer-contact-item">
              <MdEmail size={18} className="text-secondary me-2" />
              <span>{company.email}</span>
            </div>
            <div className="tff-footer-contact-item">
              <MdPhone size={18} className="text-secondary me-2" />
              <span>{company.phone}</span>
            </div>
            
          </div>

          <div className="col-12">
            <div className="tff-footer-bottom">
              <p className="text-light mNoMargin">&copy; {getCurrentYear()} {company.shortName}. All rights reserved.</p>
              <p className="text-light mNoMargin">Designed and developed by <a href="https://werenium.com" style={{textDecoration: "none"}} className="text-secondary">Werenium Technologies. </a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
